/* eslint-disable import/prefer-default-export */
export const TEAM_ACTION_TYPES = {
  FETCH_TEAMS_START: 'team/FETCH_TEAMS_START',
  FETCH_TEAMS_SUCCESS: 'team/FETCH_TEAMS_SUCCESS',
  FETCH_TEAMS_FAILURE: 'team/FETCH_TEAMS_FAILURE',
  SET_SELECTED_TEAM: 'team/SET_SELECTED_TEAM',
  RESET_STORE: 'team/RESET_STORE',
};
